import {IChipsDataTabs, IChipsGallery} from "./interfaces";

/**
 * Chips for display and hide.
 * @param {string} querySelector
 */
export const initChipsGallery = (querySelector:string) => {
    let chipsGalleryProps:any = null;
    const $gallery = document.getElementById(querySelector);
    if($gallery){
        const dataID = $gallery.getAttribute('data-id');
        const dataPageType = $gallery.getAttribute('data-page-type');
        const dataTabType = $gallery.getAttribute('data-tab-type');
        const dataTabs = $gallery.getAttribute('data-tabs');
        const dataTabsSplit = dataTabs ? dataTabs.split(';') : '';
        let chipsDataTabs:IChipsDataTabs[] = [];
        if (dataTabsSplit && dataTabsSplit.length > 0) {
            for(let i=0;i < dataTabsSplit.length ; i++){
                const dataTab = dataTabsSplit[i];
                const chipsDataTab = {
                    dataTabId:dataTab.split("|")[0],
                    dataTabName:dataTab.split("|")[1],
                    isShow: i===0,
                } as IChipsDataTabs;
                chipsDataTabs.push(chipsDataTab);
            }
        }


        chipsGalleryProps = {
            dataID: dataID,
            dataPageType: dataPageType,
            dataTabType:dataTabType,
            dataTabs: chipsDataTabs
        } as IChipsGallery;
    }
    return chipsGalleryProps;
}